module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Maximize_16"],"path":[{"$":{"d":"M4.21,2.79l2.5,2.5L5.29,6.71l-2.5-2.5L1,6V1H6ZM10,1l1.79,1.79-2.5,2.5,1.41,1.41,2.5-2.5L15,6V1ZM5.29,9.29l-2.5,2.5L1,10v5H6L4.21,13.21l2.5-2.5Zm5.41,0L9.29,10.71l2.5,2.5L10,15h5V10l-1.79,1.79Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Maximize_16.svg
// module id = ESSu
// module chunks = 1